import { GlossaryTerm, GlossaryCategory, Localized } from './types'
import { pamTerms } from './terms-pam'
import { iamTerms } from './terms-iam'
import { igaTerms } from './terms-iga'
import { pamTerms2 } from './terms-pam2'
import { iamTerms2 } from './terms-iam2'
import { igaTerms2 } from './terms-iga2'
import { threatTerms } from './terms-threats'
import { iamTerms3 } from './terms-iam3'
import { igaTerms3 } from './terms-iga3'
import { clmTerms } from './terms-clm'
import { intelTerms } from './terms-intel'
import { aiTerms } from './terms-ai'
import { infraTerms } from './terms-infra'

export * from './types'

/**
 * Freshness stamp for glossary pages (visible date + article:modified_time +
 * sitemap lastmod via next-sitemap.config.js; keep the two in sync).
 * Bump whenever term content is materially edited.
 */
export const GLOSSARY_LAST_UPDATED = '2026-09-10'

export const glossaryTerms: GlossaryTerm[] = [
  ...iamTerms,
  ...iamTerms2,
  ...iamTerms3,
  ...pamTerms,
  ...pamTerms2,
  ...igaTerms,
  ...igaTerms2,
  ...igaTerms3,
  ...threatTerms,
  ...clmTerms,
  ...intelTerms,
  ...aiTerms,
  ...infraTerms,
]

export function getGlossaryTerm(slug: string): GlossaryTerm | undefined {
  return glossaryTerms.find((t) => t.slug === slug)
}

export const glossaryCategories: { key: GlossaryCategory; label: Localized }[] = [
  { key: 'iam', label: { en: 'Identity & Access', tr: 'Kimlik ve Erişim' } },
  { key: 'pam', label: { en: 'Privileged Access', tr: 'Ayrıcalıklı Erişim' } },
  { key: 'iga', label: { en: 'Governance', tr: 'Yönetişim' } },
  { key: 'concepts', label: { en: 'Concepts', tr: 'Kavramlar' } },
]

/** Picks the right language from a Localized value; falls back to English. */
export function pick(value: Localized, locale: string): string {
  return locale === 'tr' ? value.tr || value.en : value.en
}
